module.exports = __webpack_public_path__ + "img/exchangecnyfill.20e102ba.svg";